import { render, staticRenderFns } from "./PermissionsAlertDialog.vue?vue&type=template&id=42bf0e49&"
import script from "./PermissionsAlertDialog.vue?vue&type=script&lang=js&"
export * from "./PermissionsAlertDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PermissionsAlertDialog.vue"
export default component.exports